module.exports = __webpack_public_path__ + "static/media/male-farmer_1f468-200d-1f33e-2.0d8bb2d7.png";